export function shouldInvalidateProviderOptions(path: string): boolean {
  if (path === "organizational.location" || path.startsWith("organizational.location.")) {
    return true;
  }

  if (path === "invited_modes" || path.startsWith("invited_modes.")) {
    return true;
  }

  if (path.startsWith("schedule.")) {
    return true;
  }

  if (path === "packing_list" || path.startsWith("packing_list.")) {
    return true;
  }

  return false;
}
